import React, { Fragment } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { Container, Row, Col } from "reactstrap";
import Slider from "react-slick";
import Highlight from 'react-highlight'

const ExPrep = () => {
  const settings = {
    infinite: true,
    dots: true,
    speed: 1000,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToScroll: 1,
  };

  const language = "python";
  const content1 = `#Сақина алаңы
import math
import matplotlib.pyplot as plt`;
  const content2 = `eps0=8.85e-12; k0=1/(4*math.pi*eps0);`;
  const content3 = `NZ=1000; R=0.1; q=1.03e-6;`;
  const content4 = `def f(z):
  f = k0 * q * z / (R * R + z * z) ** 1.5;
  return f`;
  const content5 = `z0=0; z1=5*R; dz=(z1-z0)/NZ;
  zmax=R/math.sqrt(2);`;
  const content6 = `print ("1. R=",R)
print (" E(R)=",f(R))
print ("2. z=",0)
print (" E(0)=",f(0))
print ("3. zmax=",zmax)
print (" Emax=",f(zmax))`;
  const content7 = `z=[]; E=[]
  z.append(0); E.append(0)`;
  const content8 = `for i in range(1,NZ):
  z2=z0+i*dz
  z.append(z2)
  E.append(f(z2))`;
  const content9 = `plt.plot(z,E,'k-')
  plt.xlabel('$z$',fontsize=20)
  plt.ylabel('$E$',fontsize=20)
  plt.show()`;

  const let1 = `  import math
  import matplotlib.pyplot as plt
  from mpl_toolkits import mplot3d
  from matplotlib.animation import FuncAnimation
  
  eps0=8.85e-12; k0=1/(4*math.pi*eps0);
  NZ=1000; R=0.1; q=1.03e-6;
  
  def f(z):
      f = k0 * q * z / (R * R + z * z) ** 1.5
      return f
  
  z0 = 0; z1 = 5*R; dz = (z1 - z0) / NZ
  zmax = R / math.sqrt(2)
  
  print("1. R = ", R)
  print(" E(R) = ", f(R))
  print("2. z = ", 0)
  print(" E(0) = ", f(0))
  print("3. zmax = ", zmax)
  print(" Emax = ", f(zmax))
  
  z = []; E = []
  z.append(0); E.append(0)
  
  for i in range(1, NZ):
      z2 = z0 + i * dz
      z.append(z2)
      E.append(f(z2))
  
  fig = plt.figure()
  ax = plt.axes(projection="3d")
  
  ax.set_xlabel('z')
  ax.set_ylabel('E')
  ax.set_zlabel('z axis')
  
  line, = ax.plot3D(z, E, z, 'gray')
  
  def update(num):
      line.set_data(z[:num], E[:num])
      line.set_3d_properties(z[:num])
      return line,
  
  ani = FuncAnimation(fig, update, frames=len(z), interval=10)
  
  plt.show()
  `;
  const let2 = `  import math
  import matplotlib.pyplot as plt
  from mpl_toolkits import mplot3d
  from matplotlib.animation import FuncAnimation
`;
  const let3 = `  eps0=8.85e-12; k0=1/(4*math.pi*eps0);
  NZ=1000; R=0.1; q=1.03e-6;`;
  const let4 = `def f(z):
  f = k0 * q * z / (R * R + z * z) ** 1.5
  return f `;
  const let5 = ``;
  const let6 = ``;
  const let7 = ``;
  const let8 = ``;

  return (
    <Fragment>
      <Header />
      <Container className="teorio-base-container teorio">
        <br /><br /><br /><br /><br /><br />
        <div className="teorio-third-container cont-teorio teorio-color-style">
          <img style={
            {
              float: 'left',
              paddingRight: '20px',
            }
          } className="rightpic" src="./image/1/1-мысал.gif" />
          <p>
            Радиусы 0,1 м жұқа сақина q = 1,03 мкКл зарядпен бірқалыпты зарядталған.
            Өріс кернеулігін анықтаңыз: 1) сақина центрі арқылы өтетін және оның жазықтығына перпендикуляр болатын келетін, осьтің бойындағы оның центрінен z=0,1м қашықтықтағы нүктедегі; 2) сақина центріндегі; 3) сақина центрінен осы ось бойында қандай қашықтықта өріс кернеулігі максималь мәнге ие болады?
          </p>
          <h2 style={
            {
              color: '#0d6efd',
            }
          }>
            <br />
            Шешімі
          </h2>
          <p>
            Симметрия тұрғысынан алып қарағанда өріс кернеулігінің векторы, суретте көрсетілгендей, центрден сақина осьі бойымен бағытталады. Өйткені ху жазықтығы бойында диаметральді орналасқан  λdl  элементар зарядтар беретін Ex, Ey құраушылары жұптап компенсацияланады, яғни   Ez = E. Сақина заряды мынаған тең q=λ2πR.   dq=λdl элементар зарядынан dEz табамыз және төмендегі өрнекті аламыз
          </p>
        </div>
        <br /><br /><br />
        <div className="teorio-container-examples">
          <div className="teorio-content-examples">
            <h6>Кітапханаларды импорттау:</h6>
            <Highlight language={language}>
              {content1}
            </Highlight>
            <h6>Бұл жолдар қажетті кітапханаларды импорттайды:
              математикалық амалдар үшін math және matplotlib.графикке арналған pyplot.
            </h6>
            <h6>Тұрақтыларды орнату:</h6>
            <Highlight language={language}>
              {content2}
            </Highlight>
            <h6>Мұнда электр өрісін есептеу формуласында қолданылатын EPS 0 электр тұрақтысы мен k0 коэффициентінің мәндері орнатылады.</h6>
            <h6>Жүйе параметрлерін орнату:</h6>
            <Highlight language={language}>
              {content3}
            </Highlight>
            <h6>Бұл жолдар жүйенің параметрлерін анықтайды:
              NZ-электр өрісі есептелетін нүктелер саны, R-заряд радиусы, q-заряд мөлшері.
            </h6>
            <h6>Электр өрісін есептеу функциясын анықтау:</h6>
            <Highlight language={language}>
              {content4}
            </Highlight>
            <h6>Мұнда f функциясы анықталады, ол z координатын дәлел ретінде қабылдайды және электр өрісінің сәйкес мәнін есептейді.</h6>
            <h6>Айнымалылар үшін бастапқы мәндерді орнату:</h6>
            <Highlight language={language}>
              {content5}
            </Highlight>
            <h6>Мұнда айнымалылар үшін бастапқы мәндер орнатылады: z0-бастапқы координат, z1-соңғы координат, dz - электр өрісі есептелетін нүктелер арасындағы қадам, Zmax-электр өрісінің максималды мәніне қол жеткізілетін координат.</h6>
            <h6>Электр өрісінің мәндерін есептеу және шығару:</h6>
            <Highlight language={language}>
              {content6}
            </Highlight>
            <h6>Мұнда бірнеше координаталық мәндер үшін электр өрісінің мәндері есептеледі: R заряд радиусында, z = 0 бастапқы нүктесінде, zmax электр өрісінің максималды мәні бар координатада. Нәтижелер экранға шығарылады.</h6>
            <h6>Электр өрісінің графигін есептеу және салу:
              7.1. Электр өрісінің координаттары мен мәндері үшін тізімдер жасау:
            </h6>
            <Highlight language={language}>
              {content7}
            </Highlight>
            <h6>Мұнда екі бос Z және E тізімдері жасалады, оларға координаттар мен сәйкес электр өрісінің мәндері қосылады.</h6>
            <h6>7.2. Электр өрісінің мәндерін есептеуге және оларды тізімдерге қосуға арналған Цикл:</h6>
            <Highlight language={language}>
              {content8}
            </Highlight>
            <h6>Мұнда z0 және z1 бастапқы және соңғы координаттары арасындағы барлық нүктелерден өтетін цикл жүреді. Әрбір z нүктесі үшін сәйкес электр өрісінің мәні f функциясы арқылы есептеледі және бұл мән E тізіміне қосылады, Z координаты z тізіміне қосылады.</h6>
            <h6>7.3. График құру:
            </h6>
            <Highlight language={language}>
              {content9}
            </Highlight>
            <h6>Мұнда matplotlib кітапханасынан plot функциясын пайдаланып график құрылады.pyplot. Графикте абсцисса осі бойынша z координаттары және ординат осі бойынша E электр өрісінің мәндері көрсетіледі. Xlabel функциясы абсцисса осі үшін қолтаңбаны, ylabel функциясы ординат осі үшін қолтаңбаны орнатады. Show функциясы графикті көрсетеді.</h6>
          </div>
        </div>
        <div className="teorio-container-examples">
          <br />
          <h2>Программаға берілген түсініктемелер</h2>
          <h6>
            Программа листингісінде қатардың реттік номерлері тек қана программаны түсіндіру үшін енгізілген, программаның мәтіндерінде қатарларды номерлеу қолданылмайды.
          </h6>
          <h6>
            Программада 01 – түсініктеме; 02 - math математикалық функцияларды есептеу пакетін қосу; 03 - E(z) (E - ң  z – ке)  тәуелділігін графикалық түрде шығару үшін matplotlib.pyplot пакетін қосу; 04-05  алғашқы деректерді анықтау; 06-08  E(z) функциясын анықтау; 09- zn есептелінетін координаталық торлар мәндерін анықтау, мұнда zn = z0 + ndz;
          </h6>
          <h6>
            10- өріс кернеулігінің zmax максималь мәнін есептеу; 11-16- есептеу қорытындысын шығару; 17- бір өлшемді массивтерді (тізімдерді) инициализациялау (z)n , (E)n; 18- z0  және  E(0) алғашқы мәндерін жазу; 19-22 - (z)n , (E)n массивтерін есептеу; 23-26 -  E(z) графигін шығару.
          </h6>
          <h2>Жауабы:</h2>
          <h6>⦁	E(R) = 0.327 MB/м; </h6>
          <h6>⦁	Е(0) = 0 МВ/м;</h6>
          <h6>⦁	zmax = 0,0707 м болғанда    Е(zmax) = 0,356 МВ/м  болады.</h6>
          <Highlight language={language}>
            {let1}
          </Highlight>
          <h2>Осы кодты біртіндеп қарастырайық.</h2>
          <h4>1. Алдымен біз қажетті кітапханалар мен модульдерді импорттаймыз:</h4>
          <Highlight language={language}>
            {let2}
          </Highlight>
          <h6><b>math</b> - математикалық функцияларға арналған модуль</h6>
          <h6><b> matplotlib.pyplot</b> – графиктер мен диаграммаларды құруға арналған модуль</h6>
          <h6><b> mpl_toolkits.mplot3d</b> - үш өлшемді графиктерді құруға арналған модуль</h6>
          <h6><b> matplotlib.animation.Funcanimation</b> - анимациялық графиктерді құруға арналған сынып</h6>
          <h4>2. Содан кейін біз бірнеше тұрақтылардың мәндерін анықтаймыз, мысалы:</h4>
          <Highlight language={language}>
            {let3}
          </Highlight>
          <h6><b> eps</b> 0-вакуумдағы электрлік тұрақты</h6>
          <h6><b> K0</b> - электростатикалық тұрақты</h6>
          <h6><b> NZ</b> - графикке арналған нүктелер саны</h6>
          <h6><b> R</b> - заряд радиусы</h6>
          <h6><b> q</b> - заряд мөлшері</h6>
          <h4>3. Содан кейін біз F(z) функциясы анықтаймыз, ол Сфераның центрінен z қашықтықта q заряды үшін кулонның Күшін есептейді:</h4>
          <Highlight language={language}>
            {let4}
          </Highlight>
          <h6><b> K0 * Q</b> - электростатикалық тұрақтыға көбейтілген заряд-бұл заряд пен электр өрісі арасындағы пропорционалдылық коэффициенті</h6>
          <h6><b> (R * R + z * z) * * 1.5 </b> - 3/2 дәрежесіне көтерілген зарядтан z нүктесіне дейінгі қашықтық, бұл зарядтың қашықтығына байланысты өрістің ыдырау коэффициенті</h6>
          <h6><b> k0 * q * z / (R * R + z * z) * * 1.5</b> - q зарядынан z нүктесінде электр өрісін есептейді.</h6>
        </div>
      </Container>
      <Footer />
    </Fragment>
  );
};

export default ExPrep;
